import FronthubError from '../../../../core/helpers/FronthubError'

export default (authorization, allowed = true) => {
  const Component = ({ permission, children, fallback, ...context }) => {
    const loading = typeof authorization === 'undefined'
    if (loading) return fallback || null
    const role =
      typeof authorization.role === 'function'
        ? authorization.role(context)
        : authorization.role
    if (typeof role !== 'string')
      throw new FronthubError('role must be a string, got ' + typeof role, role)
    if (!authorization[role]) {
      console.warn(
        [
          `front-hub: role "${role}" was not found...`,
          'Defined as: ' + String(authorization.role),
          'Actual roles:',
          Object.keys(authorization)
            .filter(r => r !== 'role')
            .join(','),
        ].join('\n'),
      )
      return null
    }
    return Object.prototype.hasOwnProperty.call(
      authorization[role],
      permission,
    ) === allowed
      ? children
      : null
  }

  Component.displayName = `Authorization.${allowed ? 'Allowed' : 'Denied'}[${
    authorization ? authorization.role : 'loading...'
  }]`
  return Component
}
